import SPT1770S from './SPT1770S'

export const parseRawData = (rawData) => {
  
}

export default SPT1770S